import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
interface TimelineStep {
  from: string;
  to: string;
  requirement: string;
  description: string;
}
interface CareerTimelineProps {
  steps: TimelineStep[];
}
export function CareerTimeline({
  steps
}: CareerTimelineProps) {
  return <div className="relative" data-id="element-524">
      <div className="absolute left-8 top-0 bottom-0 w-1 bg-gradient-to-b from-[#357BEB] to-[#21A366] hidden md:block" data-id="element-525"></div>
      <div className="space-y-8" data-id="element-526">
        {steps.map((step, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.15
      }} className="relative" data-id="element-527">
            <div className="hidden md:flex absolute left-0 w-16 h-16 bg-gradient-to-br from-[#357BEB] to-[#21A366] rounded-full items-center justify-center shadow-lg" data-id="element-528">
              <CheckCircleIcon className="w-8 h-8 text-white" data-id="element-529" />
            </div>
            <div className="md:ml-24 bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border-2 border-gray-100" data-id="element-530">
              <div className="flex items-center space-x-3 mb-4" data-id="element-531">
                <span className="text-lg font-bold text-[#132C53]" data-id="element-532">
                  {step.from}
                </span>
                <ArrowRightIcon className="w-5 h-5 text-[#357BEB]" data-id="element-533" />
                <span className="text-lg font-bold text-[#21A366]" data-id="element-534">
                  {step.to}
                </span>
              </div>
              <div className="bg-[#357BEB] bg-opacity-10 px-4 py-2 rounded-lg inline-block mb-3" data-id="element-535">
                <p className="text-sm font-semibold text-[#132C53]" data-id="element-536">
                  📋 {step.requirement}
                </p>
              </div>
              <p className="text-gray-700" data-id="element-537">{step.description}</p>
            </div>
          </motion.div>)}
      </div>
    </div>;
}